import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-客户管理",
  "use": "icon-客户管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-客户管理\">\n<path d=\"M97.4 75.2C97.4 84.1981 89.7827 91.8 80 91.8C70.2173 91.8 62.6 84.1981 62.6 75.2C62.6 66.2019 70.2173 58.6 80 58.6C89.7827 58.6 97.4 66.2019 97.4 75.2Z\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M112.8 126.4C112.8 108.285 98.1149 93.6 80 93.6C61.8851 93.6 47.2 108.285 47.2 126.4\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M21 33.8H128C134.075 33.8 139 38.7249 139 44.8V134.4C139 140.475 134.075 145.4 128 145.4H32C25.9249 145.4 21 140.475 21 134.4V33.8Z\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M141 10.4H31C25.4772 10.4 21 14.8772 21 20.4V135.4\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/客户管理.svg
// module id = XFjn
// module chunks = 26